import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function EmailThankYou() {
  return (
    <>
      <Container className="py-5">
        <Card className="shadow">
          <Card.Header as="h2" className="text-center">
            Vielen Dank!
          </Card.Header>
          <Card.Body className="text-center">
            <p className="mb-4">
              Wir haben Ihre Anfrage erhalten. Sie bekommen außerdem eine Bestätigungs-E-Mail mit einer Kopie Ihrer Angaben.
            </p>

            <div className="d-flex justify-content-center gap-2 flex-wrap">
              <Button as={Link} variant="primary" to="/">
                Zur Startseite
              </Button>
              <Button as={Link} variant="outline-secondary" to="/kontakt">
                Kontakt
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
